import React, { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form/dist/index.ie11';
import { startOfDay, subMonths, getDate } from 'date-fns';
import { BaseDateInput } from 'src/components/enterprise/components/BaseDateInput/BaseDateInput';
import {
  validateEndDate,
  getEndDateDisabledDays,
} from 'src/components/enterprise/features/Reporting/CreateReportsPage/components/Form/EndDateControl/EndDateControl.utils';
import { CreateReportFormFields } from 'src/components/enterprise/features/Reporting/CreateReportsPage/components/Form/CreateReportForm/CreateReportFormProvider';

interface EndDateControlProps {
  name: string;
  id: string;
}

export const EndDateControl: React.FC<EndDateControlProps> = ({ name, id }) => {
  const { control, trigger } = useFormContext<CreateReportFormFields>();
  const { startDate, endDate } = useWatch({ control });

  useEffect(() => {
    if (endDate !== null && endDate !== undefined) {
      trigger(name);
    }
  }, [endDate, startDate, trigger, name]);

  const today = startOfDay(new Date());
  const initialMonth = getDate(today) === 1 ? subMonths(today, 1) : today;

  return (
    <BaseDateInput
      id={id}
      name={name}
      label="End Date *"
      blockWidth
      rules={{
        required: 'End Date is required',
        validate: (value: Date | null) => validateEndDate(value, startDate),
      }}
      disabledDays={getEndDateDisabledDays(startDate, today)}
      initialMonth={initialMonth}
    />
  );
};
